module.exports = __webpack_public_path__ + "static/sid-00eee3df9e885dbbfb7ba5916d10db7a.jpeg";